import React, { useState } from "react";
import { FaClipboard } from "react-icons/fa";
import VerifyModal from "./VerifyModal";

const WinnerDisplay = ({ winners, config, sessionId, explorerUrlBase }) => {
  const [modalOpen, setModalOpen] = useState(false);

  // Helper function that abbreviates an Ethereum address.
  // It shows the first 18 characters (0x + 16 hex digits) followed by "..." and then the last 4 digits.
  const abbreviateAddress = (address) => {
    if (!address) return "";
    return `${address.slice(0, 18)}...${address.slice(-4)}`;
  };

  const handleCopy = () => {
    const winnerText = winners.join("\n");
    navigator.clipboard.writeText(winnerText).then(() => {
      alert("Winners copied to clipboard!");
    });
  };

  return (
    <div className="relative w-full max-w-3xl p-4 mx-auto text-white border border-gray-700 shadow-lg sm:p-8 bg-gradient-to-br from-gray-900 to-gray-800 rounded-2xl">
      {winners.length > 0 && (
        <button
          onClick={handleCopy}
          className="absolute text-gray-400 transition duration-300 top-4 right-4 hover:text-gray-200"
          title="Copy Winners"
        >
          <FaClipboard size={24} />
        </button>
      )}
      <h2 className="mb-8 text-3xl font-extrabold text-center text-indigo-400">
        Winners
      </h2>
      <div className="p-6 mb-8 bg-gray-800 rounded-lg shadow-inner">
        <h3 className="mb-4 text-xl font-semibold text-indigo-300">
          Configuration
        </h3>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div>
            <p className="text-sm font-medium text-gray-400">Winners</p>
            <p className="text-lg font-bold">{winners.length}</p>
          </div>
          <div>
            <p className="text-sm font-medium text-gray-400">
              Reward (STEAMX)
            </p>
            <p className="text-lg font-bold">{config?.reward || 0}</p>
          </div>
          {config?.lockType === "locked" && (
            <div>
              <p className="text-sm font-medium text-gray-400">
                Lock Duration
              </p>
              <p className="text-lg font-bold">
                {config?.lockDuration || 0} days
              </p>
            </div>
          )}
          {config?.lockType === "vested" && (
            <div>
              <p className="text-sm font-medium text-gray-400">
                Vesting Period
              </p>
              <p className="text-lg font-bold">
                {config?.vestDuration || 0} days
              </p>
            </div>
          )}
          {config?.lockType === "locked_and_vested" && (
            <>
              <div>
                <p className="text-sm font-medium text-gray-400">
                  Lock Duration
                </p>
                <p className="text-lg font-bold">
                  {config?.lockDuration || 0} days
                </p>
              </div>
              <div>
                <p className="text-sm font-medium text-gray-400">
                  Vesting Period
                </p>
                <p className="text-lg font-bold">
                  {config?.vestDuration || 0} days
                </p>
              </div>
            </>
          )}
        </div>
      </div>

      <div className="p-6 bg-gray-800 rounded-lg shadow-inner">
        <h3 className="mb-4 text-xl font-semibold text-indigo-300">Winners</h3>
        <ul className="space-y-4">
          {winners.map((winner, index) => (
            <li
              key={index}
              className="flex flex-col items-start justify-between p-4 transition-transform duration-200 transform rounded-lg shadow-md md:flex-row md:items-center bg-gradient-to-r from-indigo-500 to-purple-600 hover:scale-105"
            >
              <span className="mb-2 font-semibold text-gray-100 md:mb-0">
                Winner {index + 1}:
              </span>
              <span className="font-mono text-gray-200 break-all">
                {abbreviateAddress(winner)}
              </span>
            </li>
          ))}
        </ul>
      </div>

      <div className="flex justify-center mt-6">
        <button
          onClick={() => setModalOpen(true)}
          className="px-6 py-3 font-semibold text-white transition-colors bg-green-600 rounded-lg hover:bg-green-700"
        >
          Verify Results
        </button>
      </div>

      {modalOpen && (
        <VerifyModal
          onClose={() => setModalOpen(false)}
          sessionId={sessionId}
          explorerUrlBase={explorerUrlBase}
        />
      )}
    </div>
  );
};

export default WinnerDisplay;
